import { render } from "./RealExamRoom.vue?vue&type=template&id=7356b900&scoped=true"
import script from "./RealExamRoom.vue?vue&type=script&lang=js"
export * from "./RealExamRoom.vue?vue&type=script&lang=js"

import "./RealExamRoom.vue?vue&type=style&index=0&id=7356b900&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7356b900"]])

export default __exports__